// extracted by mini-css-extract-plugin
module.exports = {"wrap":"WithoutOrganizationView_wrap__2C6oR","content":"WithoutOrganizationView_content__3s8xj"};